var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "step-1" },
    [
      _c("i-calendar", {
        attrs: {
          timezone: _vm.bookings.timezone,
          "active-range": _vm.activeRange,
          "active-times": _vm.activeTimes,
        },
        on: { select: _vm.onSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }